export default __webpack_public_path__ + "static/media/copy.4c59a9ec.svg";